import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { blogPosts } from '../data/blogPosts';
import SEO from '../components/SEO';
import '../App.css';

const POSTS_PER_PAGE = 6;

function Blog() {
  const [currentPage, setCurrentPage] = useState(1);

  useEffect(() => {
    const handleScroll = () => {
      const elements = document.querySelectorAll('.animate-on-scroll');
      elements.forEach(element => {
        const elementTop = element.getBoundingClientRect().top;
        const elementVisible = 150;
        
        if (elementTop < window.innerHeight - elementVisible) {
          element.classList.add('animate');
        }
      });
    };

    setTimeout(() => {
      handleScroll();
    }, 100);
    
    window.addEventListener('scroll', handleScroll);
    
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, [currentPage]);

  // Pagination logic
  const totalPages = Math.ceil(blogPosts.length / POSTS_PER_PAGE);
  const startIndex = (currentPage - 1) * POSTS_PER_PAGE;
  const currentPosts = blogPosts.slice(startIndex, startIndex + POSTS_PER_PAGE);

  const goToPage = (page) => {
    setCurrentPage(Math.max(1, Math.min(page, totalPages)));
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const renderPagination = () => {
    if (totalPages <= 1) return null;

    const pages = [];
    const showPages = 5;
    let startPage = Math.max(1, currentPage - Math.floor(showPages / 2));
    let endPage = Math.min(totalPages, startPage + showPages - 1);
    if (endPage - startPage < showPages - 1) {
      startPage = Math.max(1, endPage - showPages + 1);
    }

    for (let i = startPage; i <= endPage; i++) {
      pages.push(
        <button
          key={i}
          className={`blog-pagination-btn ${i === currentPage ? 'active' : ''}`}
          onClick={() => goToPage(i)}
        >
          {i}
        </button>
      );
    }

    return (
      <nav className="blog-pagination" aria-label="Blog pagination">
        <button
          className="blog-pagination-btn blog-pagination-prev"
          onClick={() => goToPage(currentPage - 1)}
          disabled={currentPage === 1}
        >
          पिछला
        </button>
        <div className="blog-pagination-numbers">
          {pages}
        </div>
        <button
          className="blog-pagination-btn blog-pagination-next"
          onClick={() => goToPage(currentPage + 1)}
          disabled={currentPage === totalPages}
        >
          अगला
        </button>
      </nav>
    );
  };

  return (
    <div className="App">
      <SEO
        title="Blog | Nasha Mukti Kendra in Patna | Nihansh Foundation"
        description="नशा मुक्ति केंद्र पटना पर लेख — URL में nasha-mukti-kendra-in-patna। पुनर्वास, इलाज और परिवार के लिए जानकारी।"
        path="/blog"
      />
      {/* Page Hero */}
      <section 
        className="page-hero blog-hero"
        style={{
          backgroundImage: 'url(/images/Cigarette addiction.jpg)',
          backgroundSize: 'cover',
          backgroundPosition: 'center center',
          backgroundRepeat: 'no-repeat',
          position: 'relative'
        }}
      >
        <div className="page-hero-background">
          <div className="page-hero-overlay"></div>
        </div>
        <div className="page-hero-content">
          <h1 className="page-hero-title">Blog</h1>
          <p className="page-hero-subtitle">नशा मुक्ति और स्वास्थ्य से संबंधित लेख और जानकारी</p>
        </div>
      </section>

      {/* Blog Section */}
      <section className="blog-section">
        <div className="container">
          <h2 className="section-title animate-on-scroll" style={{ color: '#1e1e1e' }}>Blog Posts</h2>
          <p className="section-subtitle animate-on-scroll" style={{ color: '#64748b' }}>नशा मुक्ति, स्वास्थ्य और पुनर्वास से संबंधित नवीनतम लेख</p>
          
          <div className="blog-posts-container">
            {currentPosts.map((post) => (
              <article key={post.id} className="blog-post-card animate-on-scroll">
                <div className="blog-post-preview">
                  <div className="blog-post-image-wrapper">
                    <img 
                      src={post.images[0]} 
                      alt={post.title} 
                      className="blog-post-image"
                      loading="lazy"
                      onError={(e) => {
                        e.target.src = '/images/banner-1.jpg';
                      }}
                    />
                  </div>
                  <div className="blog-post-content">
                    <div className="blog-post-meta">
                      <span className="blog-post-date">{post.date}</span>
                      <span className="blog-post-author">{post.author}</span>
                    </div>
                    <h3 className="blog-post-title">{post.title}</h3>
                    <p className="blog-post-excerpt">{post.shortContent}</p>
                    <Link 
                      to={`/blog/${post.slug}`}
                      className="blog-read-more-btn"
                    >
                      पूरा पढ़ें
                    </Link>
                  </div>
                </div>
              </article>
            ))}
          </div>

          {renderPagination()}
        </div>
      </section>
    </div>
  );
}

export default Blog;


